// @nuxtjs/strapi configuration
export default {
    url: 'http://15.222.116.137:1337',
    prefix: '/api',
    version: 'v4',
    entities: [
        { name: 'homepage', type: 'single' },
    ],
}